import type { SelectOption } from '../../../components';
import { KANBAN_COLUMNS } from '../../../services/kanbanService';
import { TaskStatus } from '../../../types/kanban';
import { TaskFormData } from './types';

export const PRIORITY_OPTIONS: SelectOption[] = [
  { value: '', label: 'None' },
  { value: 'high', label: 'High' },
  { value: 'normal', label: 'Normal' },
  { value: 'low', label: 'Low' },
];

export const STATUS_OPTIONS: SelectOption[] = KANBAN_COLUMNS.map((c) => ({
  value: c.id,
  label: c.title,
}));

export const STATUS_LABEL: Record<TaskStatus, string> = {
  un_assigned: 'Unassigned',
  todo: 'To Do',
  waiting_for_info: 'Waiting for Info',
  in_progress: 'In Progress',
  completed: 'Completed',
};

export const INITIAL_FORM: TaskFormData = {
  title: '',
  email: '',
  description: '',
  leadId: '',
  leadUniqueId: '',
  leadUserId: '',
  columnId: 'un_assigned',
  priority: '',
  taskTypeId: '',
  dueDate: '',
  assigneeId: '',
  reporterId: '',
  labelIds: [],
};

export const DEFAULT_BREADCRUMBS = ['CRM', 'Leads', 'Task Detail'];

export const formatLeadIdLabel = (
  leadUniqueId: string | number | null | undefined
): string | null => {
  if (leadUniqueId == null || leadUniqueId === '') return null;
  const id = String(leadUniqueId).replace(/^#/, '');
  return `LEAD ID: ${id}`;
};

export const formatRelativeTime = (dateStr: string): string => {
  const date = new Date(dateStr);
  const diff = Date.now() - date.getTime();
  const hours = Math.floor(diff / (1000 * 60 * 60));

  if (hours < 1) return 'Just now';
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const days = Math.floor(hours / 24);
  if (days === 1) {
    return `Yesterday at ${date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    })}`;
  }

  return `${days} days ago`;
};

export const historyFieldLabel = (fieldName: string, value: string | null): string => {
  if (!value) return '—';
  if (fieldName === 'status') {
    return STATUS_LABEL[value as TaskStatus] ?? value;
  }
  if (fieldName === 'priority') {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  if (fieldName === 'label') {
    return value;
  }
  return value;
};
